import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'logged_out_retailers-logged_out_home_redesign-view';
/**
 * track view events on logged out home (redesign)
parameter: banner name
*/
export function trackLoggedOutRetailersLoggedOutHomeRedesignView(banner_name) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { banner_name },
    });
}
